function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module list/todolistediting
 */
import ListCommand from './listcommand';
import ListEditing from './listediting';
import TodoListCheckCommand from './todolistcheckcommand';
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import { dataModelViewInsertion, dataViewModelCheckmarkInsertion, mapModelToViewPosition, modelViewChangeChecked, modelViewChangeType, modelViewInsertion } from './todolistconverters';
import { getLocalizedArrowKeyCodeDirection } from '@ckeditor/ckeditor5-utils/src/keyboard';
/**
 * The engine of the to-do list feature. It handles creating, editing and removing to-do lists and their items.
 *
 * It registers the entire functionality of the {@link module:list/listediting~ListEditing list editing plugin} and extends
 * it with the commands:
 *
 * - `'todoList'`,
 * - `'todoListCheck'`.
 *
 * @extends module:core/plugin~Plugin
 */

var TodoListEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(TodoListEditing, _Plugin);

  var _super = _createSuper(TodoListEditing);

  function TodoListEditing() {
    _classCallCheck(this, TodoListEditing);

    return _super.apply(this, arguments);
  }

  _createClass(TodoListEditing, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var editing = editor.editing,
          data = editor.data,
          model = editor.model; // Extend schema.

      model.schema.extend('listItem', {
        allowAttributes: ['todoListChecked']
      }); // Disallow todoListChecked attribute on other nodes than listItem with to-do listType.

      model.schema.addAttributeCheck(function (context, attributeName) {
        var item = context.last;

        if (attributeName == 'todoListChecked' && item.name == 'listItem' && item.getAttribute('listType') != 'todo') {
          return false;
        }
      }); // Register commands.

      editor.commands.add('todoList', new ListCommand(editor, 'todo'));
      editor.commands.add('todoListCheck', new TodoListCheckCommand(editor)); // Define converters.

      data.downcastDispatcher.on('insert:listItem', dataModelViewInsertion(model), {
        priority: 'high'
      });
      data.upcastDispatcher.on('element:input', dataViewModelCheckmarkInsertion, {
        priority: 'high'
      });
      editing.downcastDispatcher.on('insert:listItem', modelViewInsertion(model, function (listItem) {
        return _this._handleCheckmarkChange(listItem);
      }), {
        priority: 'high'
      });
      editing.downcastDispatcher.on('attribute:listType:listItem', modelViewChangeType(function (listItem) {
        return _this._handleCheckmarkChange(listItem);
      }, editing.view));
      editing.downcastDispatcher.on('attribute:todoListChecked:listItem', modelViewChangeChecked(function (listItem) {
        return _this._handleCheckmarkChange(listItem);
      }));
      editing.mapper.on('modelToViewPosition', mapModelToViewPosition(editing.view));
      data.mapper.on('modelToViewPosition', mapModelToViewPosition(editing.view)); // Jump at the end of the previous node on left arrow key press, when selection is after the checkbox.
      //
      // <blockquote><p>Foo</p></blockquote>
      // <ul><li><checkbox/>{}Bar</li></ul>
      //
      // press: `<-`
      //
      // <blockquote><p>Foo{}</p></blockquote>
      // <ul><li><checkbox/>Bar</li></ul>
      //

      this.listenTo(editing.view.document, 'keydown', jumpOverCheckmarkOnSideArrowKeyPress(model, editor.locale)); // Toggle check state of selected to-do list items on keystroke.

      editor.keystrokes.set('Ctrl+space', function () {
        return editor.execute('todoListCheck');
      }); // Remove `todoListChecked` attribute when a host element is no longer a to-do list item.

      var listItemsToFix = new Set();
      this.listenTo(model, 'applyOperation', function (evt, args) {
        var operation = args[0];

        if (operation.type == 'rename' && operation.oldName == 'listItem') {
          var item = operation.position.nodeAfter;

          if (item.hasAttribute('todoListChecked')) {
            listItemsToFix.add(item);
          }
        } else if (operation.type == 'changeAttribute' && operation.key == 'listType' && operation.oldValue === 'todo') {
          var _iterator = _createForOfIteratorHelper(operation.range.getItems()),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _item = _step.value;

              if (_item.hasAttribute('todoListChecked') && _item.getAttribute('listType') !== 'todo') {
                listItemsToFix.add(_item);
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
      });
      model.document.registerPostFixer(function (writer) {
        var hasChanged = false;

        var _iterator2 = _createForOfIteratorHelper(listItemsToFix),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var listItem = _step2.value;
            writer.removeAttribute('todoListChecked', listItem);
            hasChanged = true;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }

        listItemsToFix.clear();
        return hasChanged;
      });
    }
    /**
     * Handles the checkbox element change, moves the selection to the corresponding model item to make it possible
     * to toggle the `todoListChecked` attribute using the command, and restores the selection position.
     *
     * Some say it's a hack :) Moving the selection only for executing the command on a certain node and restoring it after,
     * is not a clear solution. We need to design an API for using commands beyond the selection range.
     * See https://github.com/ckeditor/ckeditor5/issues/1954.
     *
     * @private
     * @param {module:engine/model/element~Element} listItem
     */

  }, {
    key: "_handleCheckmarkChange",
    value: function _handleCheckmarkChange(listItem) {
      var editor = this.editor;
      var model = editor.model;
      var previousSelectionRanges = Array.from(model.document.selection.getRanges());
      model.change(function (writer) {
        writer.setSelection(listItem, 'end');
        editor.execute('todoListCheck');
        writer.setSelection(previousSelectionRanges);
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'TodoListEditing';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [ListEditing];
    }
  }]);

  return TodoListEditing;
}(Plugin); // Handles the left/right (LTR/RTL content) arrow key and moves the selection at the end of the previous block element
// if the selection is just after the checkbox element. In other words, it jumps over the checkbox element when
// moving the selection to the left/right (LTR/RTL).
//
// @private
// @param {module:engine/model/model~Model} model
// @param {module:utils/locale~Locale} locale
// @returns {Function} Callback for 'keydown' events.


export { TodoListEditing as default };

function jumpOverCheckmarkOnSideArrowKeyPress(model, locale) {
  return function (eventInfo, domEventData) {
    var direction = getLocalizedArrowKeyCodeDirection(domEventData.keyCode, locale.contentLanguageDirection);

    if (direction != 'left') {
      return;
    }

    var schema = model.schema;
    var selection = model.document.selection;

    if (!selection.isCollapsed) {
      return;
    }

    var position = selection.getFirstPosition();
    var parent = position.parent;

    if (parent.name === 'listItem' && parent.getAttribute('listType') == 'todo' && position.isAtStart) {
      var newRange = schema.getNearestSelectionRange(model.createPositionBefore(parent), 'backward');

      if (newRange) {
        model.change(function (writer) {
          return writer.setSelection(newRange);
        });
      }

      domEventData.preventDefault();
      domEventData.stopPropagation();
      eventInfo.stop();
    }
  };
}